
import React from 'react';

type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  color?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '', color = 'border-t-teal-600' }) => {
  const sizes: Record<SpinnerSize, string> = {
    xs: 'h-4 w-4 border-2',
    sm: 'h-5 w-5 border-2',
    md: 'h-8 w-8 border-4',
    lg: 'h-12 w-12 border-4',
    xl: 'h-16 w-16 border-4',
  };

  return (
    <div
      className={`animate-spin rounded-full border-gray-200 ${color} ${sizes[size]} ${className}`.trim()}
    />
  );
};

export default Spinner;
